import {
	HubDataSource,
	HubItemCategoryModel,
	HubItemDataSource
} from "client/Api/Hub/hub";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { ActiveFilter, HubViewChangeHandler } from "../common";
import { List } from "../Events/Overview/List/List";
import styles from "./Overview.module.less";
import { EventPreviewModel } from "client/Api/Hub/Events/eventViewer";
import { ViewAll } from "./ViewAll";
import { useOverviewSection } from "./useOverviewSection";
import { TimeZone } from "client/DateAndTime/timezones";

export type EventSectionProps = {
	items: readonly EventPreviewModel[];
	isMobile: boolean;
	onViewChange: HubViewChangeHandler;
	onActiveFilterChange: (activeFilter: ActiveFilter | null) => void;
	getCategory: (categoryId: number | null) => HubItemCategoryModel | undefined;
	onSelectCategory: (source: HubItemDataSource, categoryId: number | null) => void;
	timezone: TimeZone;
};

export const EventSection = (props: EventSectionProps): ReactElement => {
	const {
		items,
		isMobile,
		onViewChange,
		getCategory,
		onActiveFilterChange,
		onSelectCategory,
		timezone
	} = props;

	const {
		viewAllHandler,
		viewItemHandler,
		activeFilterChangeHandler
	} = useOverviewSection(
		HubDataSource.Event,
		onViewChange,
		onActiveFilterChange,
		onSelectCategory
	);

	return (
		<section>
			<header className={styles.sectionHeader}>
				<h3 className={styles.sectionTitle}>
					{localize("_UpcomingEvents")}
				</h3>

				{!isMobile && (
					<ViewAll
						itemSource={HubDataSource.Event}
						onClick={viewAllHandler}
						variant="anchor"
					/>
				)}
			</header>

			<List
				items={items}
				kind="overview"
				onNavigateToItem={viewItemHandler}
				getCategory={getCategory}
				onActiveFilterChange={activeFilterChangeHandler}
				onSelectedCategoryIdChange={(x) => onSelectCategory(HubDataSource.Event, x)}
				collapseMode={{
					kind: isMobile
						? "limited-items"
						: "one-row",
					isCollapsed: true,
					maxItemsCount: isMobile
						? MAX_MOBILE_ITEMS_TO_RENDER
						: Number.MAX_SAFE_INTEGER
				}}
				shouldAlwaysRenderMoreButton
				renderMoreButton={
					isMobile
						? (
							<ViewAll
								itemSource={HubDataSource.Event}
								onClick={viewAllHandler}
								variant="list-item"
							/>
						)
						: <></>
				}
				timezone={timezone}
			/>
		</section>
	);
};
EventSection.displayName = "EventSection";

const MAX_MOBILE_ITEMS_TO_RENDER = 3;